<template>
  <div class="wrapper pagination pagination-absolute">
    <Menu />
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div v-if="data.related.news.length != 0" class="col-12 p-0">
            <carousel
              ref="newsCarousel"
              :perPage="1"
              paginationActiveColor="#fff"
              paginationColor="rgba(255,255,255,.43)"
            >
              <slide v-for="item in data.related.news" :key="item.slug">
                <div class="slider-box position-relative" @click="getNews(item.slug)">
                  <img :src="item.original" class="w-100 slider-image" />
                  <h1 class="fs-32 fc-5 slider-title position-absolute z-9">{{item.title}}</h1>
                </div>
              </slide>
            </carousel>
          </div>
          <div class="col-12 p-0">
            <div class="item-box text-center p-3">
              <h1 class="fs-14 fc-6 rb">{{data.league}}</h1>
              <span class="fs-12 fc-3">{{$dateString(data.dateTime)}}, {{data.location}}</span>
              <div class="team-band">
                <div class="team-block">
                  <div class="team one">
                    <img
                      style="width: 100px"
                      class="img-responsive"
                      :src="data.homeTeam.logo_url"
                      alt
                    />
                    <p class="fs-14 fc-2">{{data.homeTeam.name}}</p>
                  </div>
                </div>
                <div class="skor-final-home">
                  <div class="detail pt-4">
                    <p class="fs-19 fc-2 font-weight-bold m-0">
                      {{data.scores.home.final}}
                      <span class="px-1">:</span>
                      {{data.scores.away.final}}
                    </p>
                    <p class="perriod fs-14 fc-3">MS</p>
                  </div>
                </div>
                <div class="team-block">
                  <div class="team one">
                    <img
                      style="width: 100px"
                      class="img-responsive"
                      :src="data.awayTeam.logo_url"
                      alt
                    />
                    <p class="fs-14 fc-2">{{data.awayTeam.name}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-2 bb-1 bt-1">
              <div class="pl-5 pr-5">
                <table class="fs-12 fc-3 table">
                  <tr>
                    <td>T</td>
                    <td>1.P</td>
                    <td>2.P</td>
                    <td>3.P</td>
                    <td>4.P</td>
                    <td v-if="data.scores.home.Q5">5.P</td>
                    <td v-if="data.scores.home.Q6">6.P</td>
                    <td v-if="data.scores.home.Q7">7.P</td>
                    <td v-if="data.scores.home.Q8">8.P</td>
                  </tr>
                  <tr class="fc-1">
                    <td>{{data.homeTeam.name_prefix}}</td>
                    <td>{{data.scores.home.Q1}}</td>
                    <td>{{data.scores.home.Q2}}</td>
                    <td>{{data.scores.home.Q3}}</td>
                    <td>{{data.scores.home.Q4}}</td>
                    <td v-if="data.scores.home.Q5">{{data.scores.home.Q5}}</td>
                    <td v-if="data.scores.home.Q6">{{data.scores.home.Q6}}</td>
                    <td v-if="data.scores.home.Q7">{{data.scores.home.Q7}}</td>
                    <td v-if="data.scores.home.Q8">{{data.scores.home.Q8}}</td>
                  </tr>
                  <tr class="fc-2">
                    <td>{{data.awayTeam.name_prefix}}</td>
                    <td>{{data.scores.away.Q1}}</td>
                    <td>{{data.scores.away.Q2}}</td>
                    <td>{{data.scores.away.Q3}}</td>
                    <td>{{data.scores.away.Q4}}</td>
                    <td v-if="data.scores.away.Q5">{{data.scores.away.Q5}}</td>
                    <td v-if="data.scores.away.Q6">{{data.scores.away.Q6}}</td>
                    <td v-if="data.scores.away.Q7">{{data.scores.away.Q7}}</td>
                    <td v-if="data.scores.away.Q8">{{data.scores.away.Q8}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="col-12 text-center pt-3 pb-3">
            <a
              href="javascript:;"
              v-if="!$store.getters.isLogged"
              @click="$router.push({name: 'Login'})"
            >
              <img :src="$store.state.ads.nofanclub.srcUrl" alt class="w-100" />
            </a>

            <div v-if="$store.getters.isLogged">
              <iframe
                :src="$store.state.ads.home.srcUrl"
                style="width: 100%;"
                :style="'height: calc(' + (parseInt($store.state.ads.home.height.replace('%', ''))) + 'vw)'"
              ></iframe>
            </div>
          </div>

          <Leader :data="stats" v-if="stats.length != 0" />

          <div class="col-12 p-0" style="margin-top: 20px">
            <div class="tab-box">
              <div class="tab-header text-center bb-1">
                <div class="row no-gutters">
                  <div
                    class="col-6 tab-select"
                    :class="statisticsType == 'home' ? 'active' : ''"
                    @click="statisticsType = 'home'"
                  >
                    <h1
                      class="fs-16"
                      :class="tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''"
                    >{{ data.homeTeam.name }}</h1>
                  </div>
                  <div
                    class="col-6 tab-select"
                    :class="statisticsType == 'away' ? 'active' : ''"
                    @click="statisticsType = 'away'"
                  >
                    <h1
                      class="fs-16"
                      :class="tab == 'fc-1  font-weight-bold' ? 'fc-2' : ''"
                    >{{ data.awayTeam.name }}</h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="item-box p-3" style="margin-top: 0px">
              <PlayerStatistics
                v-if="statisticsType == 'home' && data.stats.home != null"
                :isAnadoluEfes="data.homeTeam.name == 'Anadolu Efes'"
                :data="data.stats.home.stats"
              />

              <PlayerStatistics
                v-if="statisticsType == 'away' && data.stats.home != null"
                :isAnadoluEfes="data.awayTeam.name == 'Anadolu Efes'"
                :data="data.stats.away.stats"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 w-100" style="position: unset">
        <Gallery :isLimited="true" :data="gallery"></Gallery>
      </div>

      <div class="col-12 w-100" v-if="data.next_match != null">
        <div class="item-box text-center p-3">
          <h1 class="fs-14 fc-6 rb">
            <span class="fc-2">Sonraki Maç:</span>
            {{$dateString(data.next_match.dateTime)}}
          </h1>
          <span class="fs-12 fc-3">{{data.next_match.court}}</span>
          <div class="row">
            <div class="col-4">
              <div class="team one">
                <img
                  style="width: 100%"
                  class="img-responsive"
                  :src="data.next_match.homeTeam.logo_url"
                  alt
                />
                <p class="fs-14 fc-2">{{data.next_match.homeTeam.name}}</p>
              </div>
            </div>
            <div class="col-4">
              <div class="detail pt-4">
                <p class="hour">-:-</p>
              </div>
            </div>
            <div class="col-4">
              <div class="team one">
                <img
                  style="width: 100%"
                  class="img-responsive"
                  :src="data.next_match.awayTeam.logo_url"
                  alt
                />
                <p class="fs-14 fc-2">{{data.next_match.awayTeam.name}}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row no-gutters bg-2 bb-1 bt-1" style="display: none">
          <div class="col-12 br-1">
            <div class="block-link text-center pt-3 pb-3">
              <h1 class="fc-1 fs-14">
                <img src="/static/img/arrow-left.svg" class="mr-2" /> Maça Bilet Al
              </h1>
            </div>
          </div>
        </div>

        <Comment @commentDeleted="getComments" :data="comments">
          <template v-slot:comment>
            <div class="add-comment">
              <div class="comment-image">
                <img :src="$store.state.user.avatarUrl" class="w-100 rounded-circle" />
              </div>
              <div class="comment-area">
                <textarea placeholder="Yorum Yaz" class="comment-input mt-2" v-model="comment"></textarea>
                <button
                  @click="sendComment"
                  class="confirm-button"
                  v-if="comment != null && comment != ''"
                >Yorum Yap</button>
              </div>
            </div>
          </template>
        </Comment>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import Gallery from "@/components/Gallery";
import Comment from "@/components/Comment";
import Leader from "@/components/Leader";
import PlayerStatistics from "@/components/PlayerStatistics";
import axios from "axios";
import moment from "moment";

export default {
  name: "HomeAfterMatch",
  props: ["title"],
  components: {
    Footer,
    Menu,
    Comment,
    PlayerStatistics,
    Leader,
    Gallery
  },
  data() {
    return {
      tab: null,
      statisticsType: "home",
      currentDate: new Date().getTime(),
      moment,
      activeTab: 1,
      data: {
        dateTime: null,
        ticket_link: null,
        previous_match: null,
        nextMatch: null,
        stats: {
          home: null
        },
        related: {
          news: []
        },
        league: null,
        fixture: null,
        homeTeam: {
          name: null,
          logo_url: ""
        },
        awayTeam: {
          name: null,
          logo_url: ""
        },
        scores: {
          home: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          },
          away: {
            final: 0,
            Q1: 21,
            Q2: 23,
            Q3: 25,
            Q4: 20
          }
        }
      },
      activeSlide: 0,
      id: this.$route.params.id || this.$store.state.app.match.id,
      stats: [],
      activeStat: "home",
      gallery: [],
      comments: [],
      comment: null,
      loading: true,
      campaigns: [],
      infoModalVisible: false,
      info: {
        bonus: { is_available: false },
        button_text: null,
        button_url: null,
        code: "XXXXXXX",
        message:
          "Tebrikler! [CODE] kodunu Kahve Dünyası mobil uygulamasından aktif edebilirsin.",
        status: true,
        user: { total_point: 0 }
      },
      latitude: null,
      longitude: null,
      checked_in: false,
      currentTime: 0
    };
  },
  methods: {
    getNews(slug) {
      this.$store.state.loading = true;
      axios.get("/haber/detay?slug=" + slug).then(res => {
        this.$store.state.loading = false;
        this.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug }
        });
      });
    },
    changeTab(tabName) {
      if (tabName == "Anadolu Efes") {
        this.isAnadoluEfes = true;
      } else {
        this.isAnadoluEfes = false;
      }
      this.tab = tabName;
    },
    getComments() {
      var data = new FormData();
      data.append("id", this.id);
      data.append("type", "match");
      data.append("user_token", this.$store.state.user.token);
      axios.post("yorum", data).then(res => {
        this.comments = res.data.data.comments;
      });
    },
    sendComment() {
      var data = new FormData();

      data.append("user_token", this.$store.state.user.token);
      data.append("comment", this.comment);
      data.append("type", "match");
      data.append("id", this.id);

      axios
        .post("yorum/ekle", data)
        .then(res => {
          if (res.data.status != true) {
            this.$notify({
              title: "Hata",
              message: res.data.data,
              type: "error"
            });
          } else {
            this.comment = null;
            this.getComments();
            this.$notify({
              title: "Başarılı",
              message: "Başarıyla yorum yapıldı.",
              type: "success"
            });
          }

          this.getComments();
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  beforeMount() {
    axios.post("kampanya/liste").then(res => {
      this.campaigns = res.data.data;
    });
    axios.get("istatistik/detay?id=" + this.id).then(res => {
      if (res.data.data.related.galleries.length != 0) {
        var g = [];
        res.data.data.related.galleries[0].gallery.map(item => {
          g.push({
            image_thumb: item.image[2].thumb_480,
            image: item.image[0].original
          });
        });

        this.gallery = g;
      }
      this.data = res.data.data;

      if (res.data.data.awayTeam.name.toLowerCase() == "anadolu efes") {
        this.statisticsType = "away";
      }

      var data = [];

      if (res.data.data.highlights) {
        data.push({
          title: "Sayı",
          ...res.data.data.highlights.topScorer,
          metric: res.data.data.highlights.topScorer.score
        });

        data.push({
          title: "Asist",
          ...res.data.data.highlights.topAssister,
          metric: res.data.data.highlights.topAssister.score
        });

        data.push({
          title: "Ribaund",
          ...res.data.data.highlights.topRebounder,
          metric: res.data.data.highlights.topRebounder.score
        });

        if (res.data.data.highlights.topStealer != undefined) {
          data.push({
            title: "Top Çalma",
            ...res.data.data.highlights.topStealer,
            metric: res.data.data.highlights.topStealer.score
          });
        }

        if (res.data.data.highlights.topBlocker != undefined) {
          data.push({
            title: "Blok",
            ...res.data.data.highlights.topBlocker,
            metric: res.data.data.highlights.topBlocker.score
          });
        }

        this.stats = data;
      } else {
        this.stats = [];
      }

      setTimeout(() => {
        this.$store.state.loading = false;
      }, 250);
    });

    this.getComments();
  },
  mounted() {
    setTimeout(() => {
      this.$refs.newsCarousel.navigateTo = this.data.related.news.length - 1;
    }, 1000);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/HomeAfterMatch.vue